<template>
  <div class="page h-100">
    <div class="container pt-82">
      <div class="font-40 color-ff font-yahei text-center mb-4">选商品</div>
      <div class=" font-yahei font-16 color-ca text-center mb-90">设计源于生活，细节成就品质</div>
      <div class="menu flex">
        <div class="flex-1 plr-30 flex-column justify-center">
          <div class="mb-30 flex align-center justify-center flex-wrap">
            <button class="btn-40 w-107 radius-round mr-10 font-16 font-yahei mb-10" :class="spaceIndex === index ? 'bg-c19357 color-ff' : 'bg-eeeff3 color-292a2e'" v-for="(item, index) in spaceList" :key="index" @click="chooseMenu(index, 'spaceIndex')">{{item.name}}</button>
          </div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-leibie.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">品类</div>
            <div class="line"></div>
            <div class="flex flex-wrap flex-1 w-0">
              <button class="menu-item font-12" :class="categoryIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'categoryIndex')">不限</button>
              <button class="menu-item font-12" :class="categoryIndex === index ? 'active' : ''" v-for="(item, index) in categoryList" :key="index" @click="chooseMenu(index, 'categoryIndex')">{{item.name}}</button>
            </div>
          </div>
          <div class="hr-dashed"></div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-fengge.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">风格</div>
            <div class="line"></div>
            <div class="flex flex-wrap flex-1 w-0">
              <button class="menu-item font-12" :class="styleIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'styleIndex')">不限</button>
              <button class="menu-item font-12" :class="styleIndex === index ? 'active' : ''" v-for="(item, index) in styleList" :key="index" @click="chooseMenu(index, 'styleIndex')">{{item.name}}</button>
            </div>
          </div>
          <div class="hr-dashed"></div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-gengduo.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei" style="flex-shrink: 0;">更多</div>
            <div class="line"  style="flex-shrink: 0;"></div>
            <button class="menu-item font-12"  style="flex-shrink: 0;" :class="moreIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'moreIndex')">不限</button>
            <div class="flex-1">
              <div class="flex align-center" v-if="standardList.length>0">
                <div class="menu-item font-12 bg-eeeff3 color-94 flex align-center" :class="moreIndex === index ? 'active' : ''" v-for="(item,index) in standardList" :key="index" @click="chooseMenu(index, 'moreIndex')">
                  <div class="mr-5 text-overflow" style="max-width:160px">{{item.name}}:{{item.str}}</div>
                  <img :src="moreIndex === index ? '/images/leibieshouqi.png':'/images/leibiexiala.png'"/>
                </div>
                <span v-if="isShow"></span>
              </div>
              <div class="flex align-center mt-10 flex-wrap" v-show="moreIndex >=0 && optionList.length>0 && standardList[moreIndex].isShow">
                <button class="border-c19357-c19357 font-12" :class="cell.selected ? 'active' : ''" v-for="(cell,cellIndex) in optionList" :key="cellIndex" @click="chooseOption(cellIndex)">{{cell.value}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex align-center flex-wrap mb-30">
        <div><img src="/images/weizhi.png" alt="" class="mr-10"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="flex-1 flex align-center flex-wrap tag">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>选商品</el-breadcrumb-item>
          <el-tag closable type="warning" size="mini" class="mr-5" @close="deleteTag('spaceIndex')" v-if="spaceIndex >=0">{{spaceList[spaceIndex].name}}</el-tag>
          <el-tag closable type="warning" size="mini" class="mr-5" @close="deleteTag('categoryIndex')" v-if="categoryIndex >=0">{{categoryList[categoryIndex].name}}</el-tag>
          <el-tag closable type="warning" size="mini" class="mr-5" @close="deleteTag('styleIndex')" v-if="styleIndex >=0">{{styleList[styleIndex].name}}</el-tag>
          <el-tag closable type="warning" size="mini" class="mr-5 mb-5" v-for="(item,index) in selectOptionList" :key="index" @close="deleteTag('moreIndex',index)">{{item.value}}</el-tag>
          <el-breadcrumb-item class="mb-5">共{{total}}个商品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="hr mb-10"></div>
      <div class="flex align-center sort mb-30">
        <button class="font-12 cursor" :class="isSales === '' && isPrice === '' ? 'color-c19357' : 'color-94'" @click="onSort('')">综合排序</button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isSales !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isSales')">
          销量
          <img :src="isSales === 1  ? '/images/paixu-jiangxu.png' : isSales === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isPrice !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isPrice')">
          价格
          <img :src="isPrice === 1  ? '/images/paixu-jiangxu.png' : isPrice === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
      </div>
      <div class="flex flex-wrap mb-40">
        <goods-item v-for="(item, index) in goodsList" :goodsItem="item" :key="index" :index="index" :isDiscount="index%6 === 0"></goods-item>
      </div>
      <el-pagination layout="prev, pager, next" :page-size="16" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import GoodsItem from '@/components/GoodsItem'
export default {
  name: 'Goods',
  components: {GoodsItem},
  props: ['keywords'],
  computed: {},
  data () {
    return {
      styleList: [],
      spaceList: [],
      categoryList: [],
      standardList: [],
      optionList: [],
      styleIndex: -1,
      spaceIndex: 0,
      moreIndex: -1,
      categoryIndex: -1,
      optionIndex: -1,
      isSales: '',
      isPrice: '',
      page:1,
      limit: 16,
      total:0,
      goodsList: [],
      isShow: false,
      selectOptionList: []
    }
  },
  created () {
    this.getStyle()
    this.getSpace()
    let that = this
    setTimeout(function(){ 
      that.getGoods()
    },1000)
    
  },
  mounted () {
  },
  watch: {
    keywords (val) {
      this.keywords = val
      this.getGoods()
    }
  },
  methods: {
    getStyle() {
      this.axios
        .post("style/list",{})
        .then(res => {
          if (res.data.success) {
            this.styleList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getSpace() {
      this.axios
        .post("space/list",{})
        .then(res => {
          if (res.data.success) {
            this.spaceList = res.data.data;
            this.getCategory ()
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getCategory () {
      this.categoryList = []
       this.axios
        .post("category/list",{spaceId: this.spaceList[this.spaceIndex].id})
        .then(res => {
          if (res.data.success) {
            this.categoryList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getStandard () {
      this.standardList = []
      this.axios
        .post("categoryStandard/optionList",{categoryId: this.categoryList[this.categoryIndex].id})
        .then(res => {
          if (res.data.success) {
            for (let i=0;i<res.data.data.length;i++) {
              res.data.data[i].isShow = false
            }
            this.standardList = res.data.data;
            this.optionList = []
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getGoods () {
      this.goodsList = []
      let params = {
        style: this.styleIndex >=0 && this.styleList.length>0 ? this.styleList[this.styleIndex].name : '',
        spaces: this.spaceIndex >=0 && this.spaceList.length>0 ? this.spaceList[this.spaceIndex].name : '',
        categoryId: this.categoryIndex >=0 && this.categoryList.length>0 ? this.categoryList[this.categoryIndex].id : '',
        optionList: this.selectOptionList,
        keywords: this.keywords,
        status: 1,
        limit: this.limit,
        page: this.page
      }
      this.axios.post(`goods/queryForPage`, params).then(res => {
        if (res.data.success) {
          // res.data.data.list.forEach(item => {
          //   item.w = 600;   //设置以大图浏览时的宽度
          //   item.h = 400;     //设置以大图浏览时的高度
          //   // item.src = item.img_url;  //大图
          //   // item.msrc = item.img_url;  //小图
          // });
          this.goodsList = res.data.data.list
          this.total = res.data.data.total
        }
      })
    },
    handleCurrentChange (e) {
      this.page = e
      this.getGoods()
    },
    chooseMenu (e, key) {
      this.isShow = !this.isShow
      if (key == 'moreIndex') {
        if (e !=-1) {
          this.standardList[e].isShow = !this.standardList[e].isShow
          this.optionList = this.standardList[e].optionList
        } else {
          this.selectOptionList = []
          this.standardList[e].isShow = false
          for (let i=0;i<this.standardList.length;i++) {
            for (let j=0;j<this.standardList[i].optionList.length;j++) {
              if (this.standardList[i].optionList[j]) {
                this.standardList[i].optionList[j].selected = false
              }
            }
          }
        }
        this[key] = e
      } else {
        this[key] = e
      if (key == 'spaceIndex') {
        this.getCategory()
        this.categoryIndex = -1
        this.moreIndex = -1
        this.optionIndex = -1
        this.optionList = []
        this.selectOptionList = []
        this.standardList = []
      }
      if (key == 'categoryIndex') {
        if (this.categoryIndex == -1) {
          this.standardList = []
          this.optionList = []
        } else {
          this.getStandard()
        }
        this.selectOptionList = []
        this.standardList = []
        this.moreIndex = -1
        this.optionIndex = -1
      }
      }
      
      this.getGoods()
    },
    deleteTag (key,index) {
      this[key] = -1
      if (key == 'moreIndex') {
        this.isShow = !this.isShow
        let arr = []
        for (let i=0;i<this.standardList.length;i++) {
          this.standardList[i].str = ''
          for (let j=0;j<this.standardList[i].optionList.length;j++) {
            if (this.standardList[i].optionList[j] && this.standardList[i].optionList[j].value == this.selectOptionList[index].value) {
              this.standardList[i].optionList[j].selected = false
            }
            if (this.standardList[i].optionList[j] && this.standardList[i].optionList[j].selected) {
              this.standardList[i].str = this.standardList[i].str +' '+ this.standardList[i].optionList[j].value
              arr.push(this.standardList[i].optionList[j])
            }
          }
        }
        this.selectOptionList = arr
      }
      this.getGoods()
    },
    chooseOption (index) {
      this.optionList[index].selected = !this.optionList[index].selected
      this.standardList[this.moreIndex].optionList = this.optionList
      this.isShow = !this.isShow
      let arr = []
      for (let i=0;i<this.standardList.length;i++) {
        this.standardList[i].str = ''
        for (let j=0;j<this.standardList[i].optionList.length;j++) {
          if (this.standardList[i].optionList[j] && this.standardList[i].optionList[j].selected) {
            this.standardList[i].str = this.standardList[i].str +' '+ this.standardList[i].optionList[j].value
            arr.push(this.standardList[i].optionList[j])
          }
        }
      }
      this.selectOptionList = arr
      this.getGoods()
    },
    onSort (key) {
      if (!key) {
        this.isSales = ''
        this.isPrice = ''
      } else {
        switch (this[key]) {
          case '':
            this.isSales = ''
            this.isPrice = ''
            this[key] = 1
          break
          case 1:
            this[key] = 0
          break
          case 0:
            this[key] = 1
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .page{
    background: #eeeff3 url('/images/xuanshangpinbg.png') no-repeat top center/auto 335px;
    padding-bottom: 105px;
  }
   .w-107{
    width: 107px;
  }
  .menu{
    background: #fff;
    border-radius: 4px;
    // height: 320px;
    box-shadow: 0px 30px 70px 0px rgba(41, 42, 46, 0.07);
    margin-bottom: 32px;
    padding: 30px 0;
    .line{
      height: 24px;
      width: 1px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    .menu-item{
      padding: 0 10px;
      height: 20px;
      line-height: 20px;
      border-radius: 10px;
      color: #7d7d7d;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 5px;
    }
    .active{
      background: #f6efe6;
      color: #c19357;
    }
    .hr-dashed{
      width: 100%;
      height: 1px;
      border-bottom: 1px dashed #e9e9e9;
      margin: 16px 0;
    }
  }
  .el-tag.el-tag--warning {
    background-color: #f6efe6;
    border-color: #f6efe6;
    color: #c19357;
    border-radius: 20px;
    padding: 0 10px;
}
  // .tag{
  //   padding: 0 10px;
  //     height: 20px;
  //     line-height: 20px;
  //     border-radius: 10px;
  //     background: #f6efe6;
  //     color: #c19357;
  //     cursor: pointer;
  //     margin-right: 10px;
  //     font-size: 12px;
  // }
  .border-c19357-c19357 {
    padding: 0 10px;
      height: 20px;
      line-height: 20px;
      white-space: nowrap;
      border-radius: 18px;
      color: #c19357;
      border:1px solid #f6efe6;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 5px;
  }
  .sort{
    .line{
      width: 1px;
      height: 12px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    button {
      padding: 0;
    }
  }
</style>
